import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import {
  IMembershipGeneralDetailsCategoryListResponseData,
  IMembershipListingResponseData,
  IMembershipUsageDetailsResponseData,
  IMembershipVisitDetailsResponseData,
} from "@/api_framework/api_modals/Membership";

export interface IMembershipState {
  membershipList: IMembershipListingResponseData[] | null;
  membershipCategoryList: IMembershipGeneralDetailsCategoryListResponseData[] | null;
  membershipUsageDetails: IMembershipUsageDetailsResponseData | null;
  membershipVisitDetails: IMembershipVisitDetailsResponseData | null;
}

export interface IMembershipInitialState extends IRouteReducerSliceStateInit {
  state: IMembershipState;
}

const initialState: IMembershipInitialState = {
  state: {
    membershipList: [],
    membershipCategoryList: [],
    membershipUsageDetails: null,
    membershipVisitDetails: null,
  },
};

const membershipSlice = createSlice({
  name: "membership_slice",
  initialState: initialState,
  reducers: {
    setMembershipList: (
      state,
      action: PayloadAction<{
        data: IMembershipListingResponseData[];
      }>,
    ) => {
      state.state.membershipList = action.payload.data;
    },
    setMembershipCategoryList: (
      state,
      action: PayloadAction<{
        data: IMembershipGeneralDetailsCategoryListResponseData[];
      }>,
    ) => {
      state.state.membershipCategoryList = action.payload.data;
    },
    setMembershipUsageDetails: (
      state,
      action: PayloadAction<{
        data: IMembershipUsageDetailsResponseData;
      }>,
    ) => {
      state.state.membershipUsageDetails = action.payload.data;
    },
    setMembershipVisitDetails: (
      state,
      action: PayloadAction<{
        data: IMembershipVisitDetailsResponseData;
      }>,
    ) => {
      state.state.membershipVisitDetails = action.payload.data;
    },
  },
});

export const { setMembershipList, setMembershipCategoryList, setMembershipUsageDetails, setMembershipVisitDetails } =
  membershipSlice.actions;
export default membershipSlice.reducer;
